import { Autocomplete } from "@mui/material";
import React, { useState } from "react";


const AutoCompeteField = ({
  id = "autocomplete",
  name,
  options = [],
  labelKey,
  valueKey,
  label,
  value,
  onChange,
  placeholder = "Select",
  disabled = false,
  className = "UI-input",
  style,
  error,
  required,
  fontsize,
  group = true
}) => {
    // const errorMsg = errors?.[name];
    const errorMsg = error
  // const [focus,setFocus] = useState(false) 

  const list = labelKey && (group && options.length>20) ?options.map((option) => {
    const firstLetter = option[labelKey]?typeof option[labelKey][0] === "string"?option[labelKey][0].toUpperCase():option[labelKey][0]:"";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  }):options
console.log(list)

  return (
    <div className="UI-form-group tw-pb-1" style={style}>
      {label && <label className="UI-label" style={{color:errorMsg && "red",fontSize:fontsize}}>{label}{required && <sup className="tw-font-normal">*</sup>}</label>}
      <div
        style={{
          position: "relative",
        }}
      >
        <Autocomplete
          id={id}
          name={name}
          options={list && list.length>0? labelKey ? list.sort((a, b) => a[labelKey] && b[labelKey] && typeof a[labelKey] === "string" &&  a[labelKey]?.localeCompare(b[labelKey]))  : list.sort():[] }
          getOptionLabel={(option) => (labelKey ? typeof option[labelKey] === "string" ? option[labelKey] : `${option[labelKey]}` : typeof option === "string" ? option : `${option}`)}
          value={(valueKey?list.find((e) => e[valueKey] === value):value )|| null}
          onChange={(event, newValue) => onChange(event, newValue)}
          // onFocus={() =>{setFocus(true)}}
          groupBy={group && options.length>20 ? (option) => option?.firstLetter : undefined}
          // onBlur={() => setFocus(false)}
          disabled={disabled}
        //   renderOption={(props, option) => {
        //     const count = labelKey?option[option.id] : 0;
        //     return (
        //         <li {...props} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        //             <span>{labelKey?option[labelKey]:option}</span>
        //             <span
        //                 style={{
        //                     color: count === 0 ? "#dc2626" : "#5f8f3f", // red for zero, gray otherwise
        //                     fontSize: "0.8rem",
        //                     whiteSpace: "nowrap",
        //                     marginLeft: "8px",
        //                 }}
        //             >
        //                 {count}
        //             </span>
        //         </li>
        //     );
        // }}
          renderInput={(params) => (
            <div ref={params.InputProps.ref}>
              <input
                type="text"
                {...params.inputProps}
                className={`UI-input ${disabled && " !tw-border-dashed !tw-bg-[#f3f4f6] "} ${errorMsg ? " !tw-border-red-500 " : " focus:!tw-border-blue-500 "} ${className}`}

                placeholder={placeholder}
                style={{
                    borderStyle:disabled && "dashed",
                    fontSize:fontsize
                }}
              />
            </div>
          )}
        />
        {value && !disabled ? (
          <span
            type="button"
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
            onClick={(e) => {
              e.stopPropagation();
              onChange(null, null);
            }}
          >
            <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
              <path
                d="M6 6L18 18M6 18L18 6"
                stroke={"#0000008a"}
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </span>
        ) : (
          <span
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
              <path
                // d="M6 9l6 6 6-6"
                d="M7 10l5 5 5-5z"
                // stroke={"#0000008a"}
                fill="#0000008a"
                // strokeWidth="2"
                // strokeLinecap="round"
                // strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
      </div>
      {errorMsg && <div>
        <p className="tw-text-[10px] tw-text-[#ff0000] m-0 tw-pt-0.5 tw-pl-1">{errorMsg}</p>
      </div>}
    </div>
  );
};

export default AutoCompeteField;
